// @ts-nocheck
/* eslint-env browser, es2021 */
/* global HTMLElement, customElements, window, fetch, alert */

class BundleBuilder extends HTMLElement {
  constructor() {
    super();
    this.steps = Array.from(this.querySelectorAll('.bundle-step'));
    this.inputs = Array.from(this.querySelectorAll('.bundle-option__input'));
    this.summaryList = this.querySelector('#bundle-summary-list');
    this.totalPriceEl = this.querySelector('#bundle-total-price');
    this.actionButton = this.querySelector('#bundle-action-button');
    this.actionButtonHome = this.actionButton?.parentElement;
    this.mobileLayout = window.matchMedia('(max-width: 749px)');
    this.handleLayoutChange = () => this.positionActionButton();
    
    this.progressSteps = Array.from(this.querySelectorAll('.bundle-progress-step'));
    this.tabContents = Array.from(this.querySelectorAll('.bundle-tab-content'));
    this.mainImage = this.querySelector('#bundle-main-image');
    
    this.currentIndex = 0;

    this.bindEvents();
    
    // Auto-select first item of the first tab if none selected
    const firstTabContent = this.tabContents[0];
    if (firstTabContent) {
      const firstInput = firstTabContent.querySelector('.bundle-option__input');
      if (firstInput && !firstInput.checked) {
        firstInput.checked = true;
      }
    }

    this.updateUI();
  }

  bindEvents() {
    // Progress Step clicks
    this.progressSteps.forEach((step, index) => {
      step.addEventListener('click', (e) => this.handleTabClick(e, index));
    });

    // Action button (Continue / Add to Cart)
    if (this.actionButton) {
      this.actionButton.addEventListener('click', this.handleActionClick.bind(this));
    }

    // Option selections
    this.inputs.forEach((input) => {
      input.addEventListener('change', this.handleSelectionChange.bind(this));
    });
  }

  connectedCallback() {
    this.mobileLayout.addEventListener('change', this.handleLayoutChange);
    this.positionActionButton();
  }

  disconnectedCallback() {
    this.mobileLayout.removeEventListener('change', this.handleLayoutChange);
  }

  positionActionButton() {
    if (!this.actionButton || !this.actionButtonHome) return;
    const showBelowOptions = this.mobileLayout.matches && this.currentIndex < this.tabContents.length - 1;
    const destination = showBelowOptions ? this.tabContents[this.currentIndex] : this.actionButtonHome;
    if (destination && this.actionButton.parentElement !== destination) {
      destination.append(this.actionButton);
    }
  }

  handleActionClick() {
    if (this.currentIndex < this.tabContents.length - 1) {
      // Go to next step
      this.goToStep(this.currentIndex + 1);
    } else {
      // Last step: Add to Cart
      this.addToCart();
    }
  }

  handleTabClick(event, index) {
    const errorEl = this.querySelector('#bundle-base-error');

    // Prevent skipping Base (index 0) if nothing selected
    if (index > 0) {
      const baseTabContent = this.tabContents[0];
      const baseChecked = baseTabContent ? baseTabContent.querySelectorAll('.bundle-option__input:checked') : [];
      if (baseChecked.length === 0) {
        if (errorEl) {
          errorEl.style.display = 'block';
          errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        return;
      }
    }

    if (errorEl) {
      errorEl.style.display = 'none';
    }

    this.goToStep(index);
  }
  
  goToStep(index) {
    if (index < 0 || index >= this.tabContents.length) return;
    
    this.currentIndex = index;
    
    // Deactivate all
    this.progressSteps.forEach(step => step.classList.remove('is-active', 'is-completed'));
    this.tabContents.forEach(content => content.classList.remove('is-active'));
    
    // Update states
    this.progressSteps.forEach((step, i) => {
      if (i < this.currentIndex) {
        step.classList.add('is-completed');
      } else if (i === this.currentIndex) {
        step.classList.add('is-active');
      }
    });
    
    const targetId = this.progressSteps[this.currentIndex].dataset.target;
    const targetContent = this.querySelector(`#${targetId}`);
    if (targetContent) {
      targetContent.classList.add('is-active');
    }
    
    this.updateUI();
    
    // On mobile, scroll up to the steps
    if (window.innerWidth < 990) {
      this.progressSteps[this.currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  handleSelectionChange(event) {
    const input = event.target;
    const stepEl = input.closest('.bundle-step');
    const limit = parseInt(stepEl.dataset.limit || '1', 10);
    const checkedInputs = Array.from(stepEl.querySelectorAll('.bundle-option__input:checked'));

    // Hide base error message
    const baseTabContent = this.tabContents[0];
    if (baseTabContent) {
      const baseChecked = baseTabContent.querySelectorAll('.bundle-option__input:checked');
      if (baseChecked.length > 0) {
        const errorEl = this.querySelector('#bundle-base-error');
        if (errorEl) errorEl.style.display = 'none';
      }
    }

    // Handle limits
    if (limit === 1) {
      if (input.checked) {
        checkedInputs.forEach((checkedInput) => {
          if (checkedInput !== input) checkedInput.checked = false;
        });
      }
    } else {
      if (checkedInputs.length > limit) {
        input.checked = false;
        window.alert(`You can only select up to ${limit} items in this step.`);
        return;
      }
    }

    // Auto-advance logic disabled to match typical "Build your own" wizard flows
    // User explicitly uses the continue button

    this.updateUI();
  }

  updateUI() {
    let totalCents = 0;
    let selectedItemsList = []; // For add to cart
    
    // Build summary list data
    let summaryHTML = '';

    this.steps.forEach((step) => {
      const stepTitle = step.dataset.title;
      const inputs = Array.from(step.querySelectorAll('.bundle-option__input:checked'));
      
      let itemsHTML = '';
      if (inputs.length > 0) {
        const itemNames = inputs.map(i => i.dataset.title).join(', ');
        
        let imagesHTML = '';
        inputs.forEach(i => {
          if (i.dataset.image) {
             imagesHTML += `<img src="${i.dataset.image}" alt="">`;
          }
        });
        
        itemsHTML = `<div class="bundle-summary-items">
          <div class="bundle-summary-images">${imagesHTML}</div>
          <div class="bundle-summary-names">${itemNames}</div>
        </div>`;
        
        inputs.forEach(i => {
           const price = parseInt(i.dataset.price || '0', 10);
           totalCents += price;
           selectedItemsList.push(i);
        });
      } else {
        itemsHTML = `<div class="bundle-summary-items"><span class="not-selected">Not selected</span></div>`;
      }
      
      summaryHTML += `
        <li>
          <span class="bundle-summary-category">${stepTitle}</span>
          ${itemsHTML}
        </li>
      `;
    });

    // Render list
    if (this.summaryList) {
      this.summaryList.innerHTML = summaryHTML;
    }

    // Render price
    if (this.totalPriceEl) {
      this.totalPriceEl.textContent = this.formatMoney(totalCents);
    }

    // Enable/Disable Action Button
    if (this.actionButton) {
      // require base to be selected to proceed
      const baseTabContent = this.tabContents[0];
      const baseChecked = baseTabContent ? baseTabContent.querySelectorAll('.bundle-option__input:checked').length > 0 : false;
      
      this.actionButton.disabled = !baseChecked;
      
      if (this.currentIndex < this.tabContents.length - 1) {
         const nextStepTitle = this.progressSteps[this.currentIndex + 1].dataset.target.replace('step-', ''); 
         // Assuming ID matches a recognizable name, but we can also get label
         const nextLabel = this.progressSteps[this.currentIndex + 1].querySelector('.bundle-progress-step__label').textContent;
         this.actionButton.innerHTML = `CONTINUE TO ${nextLabel} &rarr;`;
      } else {
         this.actionButton.innerHTML = `ADD TO CART`;
      }
    }
    
    // Store selected items for addToCart
    this.selectedInputsForCart = selectedItemsList;
    this.positionActionButton();
  }

  formatMoney(cents) {
    if (!cents) cents = 0;
    const format = window.Shopify.money_format || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    if (format.includes('{' + '{')) {
      return format.replace(/\{\{\s*.*?amount.*?\s*\}\}/, value);
    }
    return format + value;
  }

  async addToCart() {
    this.actionButton.disabled = true;
    const originalText = this.actionButton.innerHTML;
    this.actionButton.innerHTML = 'Adding...';

    const checkedInputs = this.selectedInputsForCart || [];

    // Build bundle metadata
    const bundleId = 'bundle-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    const bundleTitles = checkedInputs.map(i => i.dataset.title).join('||');
    const bundleImages = checkedInputs.map(i => i.dataset.image || '').join('||');
    const bundleCount = checkedInputs.length;
    const baseTitle = checkedInputs[0]?.dataset.title || 'Granola Bag';

    try {
      const cartRoot = window.Shopify.routes?.root || '/';
      const cartResponse = await fetch(`${cartRoot}cart.js`);
      if (!cartResponse.ok) throw new Error('Could not read the cart');
      const cart = await cartResponse.json();
      const existingBundleIds = new Set();
      const existingHues = [];
      const usedMarkers = new Set();
      const bundleColors = ['🟡', '🔵', '🟢', '🟣', '🟠', '🔴'];
      let highestBundleNumber = 0;
      (cart.items || []).forEach((item) => {
        const properties = item.properties || {};
        if (!properties._bundle_id) return;
        if (!existingBundleIds.has(properties._bundle_id)) {
          const hue = Number(properties._bundle_hue);
          if (Number.isInteger(hue) && hue >= 0 && hue < 360) existingHues.push(hue);
          const marker = bundleColors.find((color) => (properties.Bundle || '').startsWith(color));
          if (marker) usedMarkers.add(marker);
        }
        existingBundleIds.add(properties._bundle_id);
        const match = /Bundle (\d+)$/i.exec(properties.Bundle || '');
        if (match) highestBundleNumber = Math.max(highestBundleNumber, Number(match[1]));
      });
      const bundleNumber = Math.max(existingBundleIds.size, highestBundleNumber) + 1;
      const availableMarkers = bundleColors.filter((color) => !usedMarkers.has(color));
      const markerPool = availableMarkers.length ? availableMarkers : bundleColors;
      const marker = markerPool[Math.floor(Math.random() * markerPool.length)];
      let bundleHue = Math.floor(Math.random() * 360);
      let bestDistance = -1;
      for (let attempt = 0; attempt < 24; attempt++) {
        const candidate = Math.floor(Math.random() * 360);
        const distance = existingHues.length
          ? Math.min(...existingHues.map((hue) => Math.min(Math.abs(hue - candidate), 360 - Math.abs(hue - candidate))))
          : 180;
        if (distance > bestDistance) {
          bundleHue = candidate;
          bestDistance = distance;
        }
      }
      const bundleLabel = `${marker} BUNDLE ${bundleNumber}`;

      const items = checkedInputs.map((input, index) => ({
        id: parseInt(input.value, 10),
        quantity: 1,
        properties: {
          '_bundle_id': bundleId,
          '_bundle_titles': bundleTitles,
          '_bundle_images': bundleImages,
          '_bundle_count': bundleCount,
          '_bundle_index': index,
          '_bundle_hue': bundleHue,
          'Bundle': bundleLabel,
          ...(index > 0 ? { 'Add-on for': baseTitle } : {})
        }
      }));

      const response = await fetch(`${cartRoot}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      // Open the custom cart drawer
      if (typeof window.toggleCartDrawer === 'function') {
        window.toggleCartDrawer(true);
      } else {
        window.location.href = '/cart';
      }

    } catch (error) {
      console.error(error);
      window.alert('There was an error adding the bundle to your cart. Please try again.');
    } finally {
      this.actionButton.innerHTML = originalText;
      this.actionButton.disabled = false;
    }
  }
}

if (!customElements.get('bundle-builder')) {
  customElements.define('bundle-builder', BundleBuilder);
}
